import fp from 'lodash/fp';

export const getImage = fp.get('value');

export const hasImage = fp.compose(fp.isNil, fp.get('value'));

export const isFromURL = fp.compose(fp.isString, fp.get('value'));

export const createImageURL = fp.compose(URL.createObjectURL, getImage);
